angular.module('blacklist', ['ngRoute', 'ngResource', 'core', 'core.auth', 'core.env', 'pascalprecht.translate', 'uiGmapgoogle-maps']);



// WEBPACK FOOTER //
// ./src/app/blacklist/blacklist.module.js